import axios from '@/extra-functions/axios.extra'
import { errorHandler } from './../extra-functions/store.extra'
import LocalStore from '../lib/localStore'
import { debugLog } from '../lib/electron-utils'
// import Store from 'electron-store'

const store = new LocalStore()
// const store = new Store()

const state = {
  loggedIn: false,
  token: null,
  errors: [],
  loggingIn: false,
  sessionExpired: false,
  user: {
    id: null,
    name: null,
    username: null,
    email: null,
    admin_code: null,
    role: null,
  },
  userPermissions: new Set(),
}

const mutations = {
  LOG_IN(state) {
    state.loggedIn = true
  },
  LOG_OUT(state) {
    state.loggedIn = false
  },
  SET_TOKEN(state, payload) {
    state.token = payload
  },
  SET_ERRORS(state, payload) {
    state.errors = payload
  },
  LOGGING_IN_TRUE(state) {
    state.loggingIn = true
  },
  LOGGING_IN_FALSE(state) {
    state.loggingIn = false
  },
  SESSION_EXPIRED_FALSE(state) {
    state.sessionExpired = false
  },
  SESSION_EXPIRED_TRUE(state) {
    state.sessionExpired = true
  },
  SET_USER(state, payload) {
    state.user = payload
  },
  SET_USER_PERMISSIONS(state, payload) {
    state.userPermissions = new Set(payload)
  },
}

const actions = {
  async login({ state, commit }, { username, password }) {
    try {
      if (state.loggedIn || state.loggingIn) return
      commit('LOGGING_IN_TRUE')
      commit('SET_ERRORS', [])
      const { data } = await axios().post('login', {
        username, password,
      })
      commit('SESSION_EXPIRED_FALSE')
      commit('SET_TOKEN', data.token.original.access_token)
      commit('SET_USER', data.user)
      commit('LOG_IN')
      store.set({
        auth: {
          token: data.token.original.access_token,
          user: data.user,
          stores: data.stores,
          storeId: data.store_id,
          permissions: data.permissions,
        },
      })
      commit('SET_USER_PERMISSIONS', data.permissions)
      return {
        token: data.token.original.access_token,
        user: data.user,
        stores: data.stores,
        storeId: data.store_id,
      }
    } catch (e) {
      commit('SET_ERRORS', errorHandler(errors))
    } finally {
      commit('LOGGING_IN_FALSE')
    }
    // return http.post('login', {
    //     username,
    //     password,
    //   }).then(({ data }) => {
    //     commit('SESSION_EXPIRED_FALSE')
    //     commit('SET_TOKEN', data.token.original.access_token)
    //     commit('SET_USER', data.user)
    //     commit('LOG_IN')
    // store.set('auth', JSON.stringify({
    //   token: data.token.original.access_token,
    //   user: data.user,
    // }))
    //   }).catch(errors => {
    //     commit('SET_ERRORS', errorHandler(errors))
    //   }).then(() => commit('LOGGING_IN_FALSE'))
  },
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  setUser({ commit }, user) {
    commit('SET_USER', user)
  },
  setLogin({ commit }) {
    commit('LOG_IN', true)
  },
  sessionExpired({ commit }) {
    commit('SESSION_EXPIRED_TRUE')
  },
  logout({ commit }) {
    commit('SET_TOKEN', null)
    commit('LOG_OUT')
    store.delete('auth')
    localStorage.clear()
  },
  setUserPermissions({ commit }, payload) {
    commit('SET_USER_PERMISSIONS', payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  strict: true,
}
